import { get } from 'lodash';

// local dependencies
import { getStore } from 'store';
import { REDUCER } from 'constants/entity-names';

// get store
const store = getStore();

/**
 * @type {function}
 * @desc Get service endpoint URL from the Redux store.
 * @example
 * import { getEndpoint } from 'utils/getEndpoint';
 * const result = getEndpoint( ...args );
 */
export const getEndpoint = ( key ) => {
    const URLS = store.getState()[ REDUCER.URLS ];
	return get( URLS, key, null );
};
